// src/Logout.js
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Logout() {
  const navigate = useNavigate();

  useEffect(() => {
    // Call the backend logout endpoint
    fetch("https://auth.fnrewards.com/api/logout", {
      method: "POST",
      credentials: "include"
    })
      .then(() => {
        // Clear any client-side stored session info (for admin or user)
        localStorage.removeItem("adminUser");
        // Redirect to home after logging out
        navigate("/");
      })
      .catch(err => {
        console.error("Logout failed:", err);
        navigate("/");
      });
  }, [navigate]);

  return (
    <div style={{ padding: "20px" }}>
      <h1>Logging Out...</h1>
    </div>
  );
}

export default Logout;